document.addEventListener("DOMContentLoaded", () => {
  // ==========================================================
  // === PRODUCT STACKING SCRIPT (FINAL COMPLETE NO COMMENTS) ===
  // ==========================================================

  // --- State & Variables ---
  const quickViewModal = document.querySelector("[data-quick-view-modal]");
  const quickViewOverlay = document.querySelector("[data-quick-view-overlay]");
  const quickViewContent = document.querySelector("[data-quick-view-content]");
  const quickViewCloseBtn = document.querySelector("[data-quick-view-close]");
  const sizeDrawer = document.querySelector("[data-qv-size-drawer]");
  const stackContainer = document.getElementById("product-stack-container");
  const sizeGuideModal = document.getElementById("sizeGuideModal");
  const sizeGuideOverlay = document.getElementById("sizeGuideOverlay");
  const sizeGuideContent = document.querySelector("[data-size-guide-content]");
  const shopMoneyFormat = window.shopMoneyFormat || "${{amount}}"; // Ambil dari theme.liquid

  let currentProductData = null;
  let stackedProducts = [];

  // --- Helper Functions ---
  function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      let parts = number.split(".");
      let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      let cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    const match = formatString.match(placeholderRegex);
    // GANTI BAGIAN AKHIR FUNGSI formatMoney MENJADI SEPERTI INI:
    if (match && match[1]) {
      switch (match[1]) {
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0, ",", ".");
          break;
        default:
          value = formatWithDelimiters(cents, 2, ",", ".");
          break;
      }
      // Langsung return format string yang sudah diisi angka, tanpa menghapus simbol
      return formatString.replace(placeholderRegex, value);
    } else if (formatString.includes("amount")) {
      // Fallback jika regex gagal tapi 'amount' ada
      return formatString.replace("{{amount}}", formatWithDelimiters(cents, 2, ",", "."));
    }
    // Fallback paling akhir
    console.warn("Using default money format due to unrecognized format:", formatString);
    // Default fallback mungkin perlu menyertakan simbol secara manual jika formatString aneh
    const defaultFormattedAmount = formatWithDelimiters(cents, 2, ",", ".");
    // Coba tebak simbol dari format string umum atau setting toko (jika bisa diakses)
    // Contoh sederhana:
    if (formatString.includes("Rp")) return "Rp " + defaultFormattedAmount;
    if (formatString.includes("$")) return "$" + defaultFormattedAmount;
    return defaultFormattedAmount; // Fallback tanpa simbol jika tidak dikenali
  }

  const openQuickView = () => {
    if (!quickViewModal || !quickViewOverlay) return;
    quickViewModal.classList.add("is-active");
    quickViewOverlay.classList.add("is-active");
    document.body.style.overflow = "hidden";
  };

  const closeQuickView = () => {
    if (!quickViewModal || !quickViewOverlay) return;
    quickViewModal.classList.remove("is-active");
    quickViewOverlay.classList.remove("is-active");
    document.body.style.overflow = "";
    if (quickViewContent)
      quickViewContent.innerHTML = '<div class="quick-view-modal__loader">Loading...</div>';
    closeSizeDrawer();
    closeSizeGuideModal();
  };

  const openSizeDrawer = () => {
    if (!sizeDrawer || !currentProductData) return;
    const sizeOptionsContainer = sizeDrawer.querySelector("[data-qv-size-options]");
    const productOptionNames = currentProductData.options.map((opt) => opt.name);
    const sizeOptionIndex = productOptionNames.findIndex((name) => name.toLowerCase() === "size");
    if (sizeOptionIndex === -1) return;
    const sizeOption = currentProductData.options[sizeOptionIndex];
    let otherSelections = {};
    document.querySelectorAll(".qv-variant-btn").forEach((btn, index) => {
      if (index !== sizeOptionIndex) {
        const optionName = productOptionNames[index];
        const optionValue = btn.querySelector("strong").textContent.trim();
        otherSelections[optionName] = optionValue;
      }
    });
    const selectedSizeEl = document.querySelector(`[data-selected-option-${sizeOptionIndex}]`);
    const selectedSize = selectedSizeEl ? selectedSizeEl.textContent.trim() : "";
    if (sizeOption) {
      sizeOptionsContainer.innerHTML = sizeOption.values
        .map((sizeValue) => {
          const selectionsForCheck = { ...otherSelections, Size: sizeValue };
          const variant = currentProductData.variants.find((v) =>
            v.options.every((optVal, i) => {
              const optName = productOptionNames[i];
              return optVal === selectionsForCheck[optName];
            })
          );
          const isAvailable = variant ? variant.available : false;
          const isSelected = sizeValue === selectedSize;
          return `<button class="qv-size-pill ${isSelected ? "is-selected" : ""}" ${!isAvailable ? "disabled" : ""}>${sizeValue}</button>`;
        })
        .join("");
    }
    sizeDrawer.classList.add("is-active");
  };

  const closeSizeDrawer = () => {
    if (sizeDrawer) sizeDrawer.classList.remove("is-active");
  };

  const openSizeGuideModal = () => {
    if (sizeGuideModal) sizeGuideModal.classList.add("is-active");
    if (sizeGuideOverlay) sizeGuideOverlay.classList.add("is-active");
    document.body.classList.add("size-guide-modal-open");
  };

  const closeSizeGuideModal = () => {
    if (sizeGuideModal) sizeGuideModal.classList.remove("is-active");
    if (sizeGuideOverlay) sizeGuideOverlay.classList.remove("is-active");
    document.body.classList.remove("size-guide-modal-open");
    if (sizeGuideContent) sizeGuideContent.innerHTML = "<p>Loading size guide...</p>";
  };

  const renderStackedItems = () => {
    if (!stackContainer) return;
    stackContainer.innerHTML = "";
    stackedProducts.forEach((productData) => {
      const variant = productData.selectedVariant;
      const product = productData.productDetails;
      const cardHtml = `
        <div class="stacked-item-card" data-handle="${product.handle}" data-variant-id="${variant.id}">
          <div class="qv-layout">
            <div class="qv-slider-wrapper">
              <div class="qv-slider"><div class="qv-slider__slide is-active"><img src="${variant.featured_image ? variant.featured_image.src : product.featured_image}" alt="${product.title}"></div></div>
            </div>
            <div class="qv-content-wrapper">
              <div class="qv-title-row">
                <h2 class="qv-product-title">${product.title}</h2>
                <button class="stacked-item-remove" data-action="remove-from-stack-direct" data-variant-id="${variant.id}">&times;</button>
              </div>
              <div class="qv-variant-row">${product.options.map((option, index) => `<button type="button" class="qv-variant-btn"><span>${option.name}</span><strong>${variant.options[index]}</strong></button>`).join("")}</div>
              <div class="qv-action-row">
                <a href="${product.url}" class="qv-btn qv-btn--secondary">Detail</a>
                <form action="/cart/add" method="post" class="qv-product__form" data-ajax-cart-form><input type="hidden" name="id" value="${variant.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="qv-btn qv-btn--primary"><span>Add</span><span class="qv-btn__price">${formatMoney(variant.price, shopMoneyFormat)}</span></button></form>
              </div>
            </div>
          </div>
        </div>`;
      stackContainer.innerHTML += cardHtml;
    });
  };

  const initQuickViewSlider = (modalContent) => {
    const slider = modalContent.querySelector("[data-qv-slider]");
    const indicators = modalContent.querySelectorAll("[data-qv-indicators] button");
    const slides = modalContent.querySelectorAll(".qv-slider__slide");

    if (!slider || !indicators || indicators.length === 0 || !slides || slides.length === 0) {
      console.warn("Slider elements not found for initQuickViewSlider");
      const indicatorContainer = modalContent.querySelector("[data-qv-indicators]");
      if (indicatorContainer) indicatorContainer.style.display = "none";
      return;
    } else {
      // Pastikan kontainer indikator terlihat jika elemen ditemukan
      const indicatorContainer = modalContent.querySelector("[data-qv-indicators]");
      if (indicatorContainer) indicatorContainer.style.display = "flex"; // Atau 'block', sesuai stylingmu
    }

    const showSlide = (index) => {
      if (index < 0 || index >= slides.length) return;
      slides.forEach((slide) => slide.classList.remove("is-active"));
      indicators.forEach((indicator) => indicator.classList.remove("is-active"));
      slides[index].classList.add("is-active");
      indicators[index].classList.add("is-active");
    };

    indicators.forEach((indicator, index) => {
      indicator.addEventListener("click", () => showSlide(index));
    });

    showSlide(0);
  };

  const fetchAndShowQuickView = async (
    productHandle,
    variantIdToSelect = null,
    isFocusView = false
  ) => {
    openQuickView();
    if (quickViewModal) quickViewModal.classList.toggle("is-focus-view", isFocusView);
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error("Product not found");
      const product = await response.json();
      currentProductData = product;
      const selectedVariant = variantIdToSelect
        ? product.variants.find((v) => v.id == variantIdToSelect)
        : product.variants[0];

      const productHtml = `
        ${
          isFocusView
            ? `
          <div class="qv-modal-actions">
            <button class="qv-svg-btn" data-action="remove-from-stack-focus" title="Remove from Stack">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </button>
             <button class="qv-svg-btn" data-action="minimize-focus-view" title="Minimize">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus-icon lucide-minus"><path d="M5 12h14"/></svg>
            </button>
          </div>
        `
            : ""
        }
        <div class="qv-layout">
          <div class="qv-slider-wrapper">
            <div class="qv-slider" data-qv-slider>
              ${product.media
                .map(
                  (media, index) => `
                <div class="qv-slider__slide" data-slide-index="${index}">
                  <img src="${media.src.replace(/(\.jpg|\.png|\.gif|\.jpeg)/, "_1024x$1")}" alt="${media.alt || product.title}">
                </div>`
                )
                .join("")}
            </div>
            ${!isFocusView ? `<div class="qv-plus-icon" data-action="stack-product" title="Add to Stack">+</div>` : ""}
          </div>
          <div class="qv-content-wrapper">
            <div class="qv-title-row">
              <h2 class="qv-product-title">${product.title}</h2>
              <div class="qv-slider-indicators" data-qv-indicators>${product.media.map((_, index) => `<button class="qv-indicator" data-indicator-index="${index}"></button>`).join("")}</div>
            </div>
            <div class="qv-variant-row">${product.options.map((option, index) => `<button type="button" class="qv-variant-btn" data-action="open-${option.name.toLowerCase()}-selector"><span>${option.name}</span><strong data-selected-option-${index}>${selectedVariant.options[index]}</strong></button>`).join("")}</div>
            <div class="qv-action-row">
              <a href="${product.url}" class="qv-btn qv-btn--secondary">Product Detail</a>
              <form action="/cart/add" method="post" enctype="multipart/form-data" class="qv-product__form" data-ajax-cart-form><input type="hidden" name="id" value="${selectedVariant.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="qv-btn qv-btn--primary"><span>Add to cart</span><span class="qv-btn__price">${formatMoney(selectedVariant.price, shopMoneyFormat)}</span></button></form>
            </div>
          </div>
        </div>
      `;

      if (quickViewContent) quickViewContent.innerHTML = productHtml;

      initQuickViewSlider(quickViewContent);
    } catch (error) {
      console.error("Quick View Error:", error);
      if (quickViewContent)
        quickViewContent.innerHTML = `<p style="padding: 2rem;">Sorry, something went wrong. Please try again.</p>`;
    }
  };

  // --- Main Event Listeners ---
  if (quickViewCloseBtn) quickViewCloseBtn.addEventListener("click", closeQuickView);
  if (quickViewOverlay) quickViewOverlay.addEventListener("click", closeQuickView);

  document.addEventListener("click", async (e) => {
    // Buka Quick View
    const quickViewTrigger = e.target.closest(".btn-quick-view");
    if (quickViewTrigger) {
      e.preventDefault();
      const handle = quickViewTrigger.dataset.productHandle;
      if (handle) fetchAndShowQuickView(handle, null, false);
    }

    // Buka Focus View
    const stackedCardTrigger = e.target.closest(".stacked-item-card");
    if (stackedCardTrigger && !e.target.matches(".stacked-item-remove")) {
      const handle = stackedCardTrigger.dataset.handle;
      const variantId = stackedCardTrigger.dataset.variantId;
      if (handle) fetchAndShowQuickView(handle, variantId, true);
    }

    // Tombol Aksi di Focus View & Stack
    if (e.target.closest('[data-action="minimize-focus-view"]')) {
      closeQuickView();
    }
    if (e.target.closest('[data-action="remove-from-stack-focus"]')) {
      const variantId = currentProductData?.variants.find(
        (v) => v.id == quickViewContent?.querySelector('input[name="id"]').value
      )?.id;
      if (variantId) {
        stackedProducts = stackedProducts.filter((p) => p.selectedVariant.id != variantId);
        renderStackedItems();
        closeQuickView();
      }
    }
    if (e.target.matches('[data-action="remove-from-stack-direct"]')) {
      const variantId = e.target.dataset.variantId;
      stackedProducts = stackedProducts.filter((p) => p.selectedVariant.id != variantId);
      renderStackedItems();
    }

    // Stack Product
    if (e.target.matches('[data-action="stack-product"]')) {
      const isDesktop = window.matchMedia("(min-width: 750px)").matches;
      const stackLimit = isDesktop ? 4 : 2;
      if (stackedProducts.length >= stackLimit) {
        alert(`You can only stack a maximum of ${stackLimit} items.`);
        return;
      }
      const form = quickViewContent?.querySelector(".qv-product__form");
      if (!form) return;
      const selectedVariantId = form.querySelector('input[name="id"]').value;
      const selectedVariant = currentProductData?.variants.find((v) => v.id == selectedVariantId);
      if (!selectedVariant) return;

      const isAlreadyStacked = stackedProducts.some(
        (item) => item.selectedVariant.id == selectedVariantId
      );
      if (!isAlreadyStacked && currentProductData) {
        stackedProducts.push({
          handle: currentProductData.handle,
          productDetails: currentProductData,
          selectedVariant: selectedVariant,
        });
        renderStackedItems();
      }
      closeQuickView();
    }

    // Buka/Tutup Size Drawer
    if (e.target.closest('[data-action="open-size-selector"]')) {
      openSizeDrawer();
    }
    if (e.target.closest('[data-action="close-size-selector"]')) {
      closeSizeDrawer();
    }

    // Handle klik pada size pill
    if (e.target.matches(".qv-size-pill")) {
      if (!currentProductData) return;
      const clickedPill = e.target;
      const newSelectedSize = clickedPill.textContent.trim();
      const productOptionNames = currentProductData.options.map((opt) => opt.name);
      let currentSelections = {};
      document.querySelectorAll(".qv-variant-btn").forEach((btn, index) => {
        const optionName = productOptionNames[index];
        let optionValue = btn.querySelector("strong").textContent.trim();
        currentSelections[optionName] = optionValue;
      });
      currentSelections["Size"] = newSelectedSize;
      const foundVariant = currentProductData.variants.find((variant) => {
        return variant.options.every((variantOptionValue, index) => {
          const optionName = productOptionNames[index];
          return variantOptionValue === currentSelections[optionName];
        });
      });
      if (foundVariant) {
        const form = document.querySelector(".qv-product__form"); // Perlu lebih spesifik jika ada form lain
        const priceEl = document.querySelector(".qv-btn__price"); // Perlu lebih spesifik
        const sizeDisplayEl = document.querySelector("[data-selected-option-1]"); // Perlu lebih spesifik

        if (form) form.querySelector('input[name="id"]').value = foundVariant.id;
        if (priceEl) {
          priceEl.textContent = formatMoney(foundVariant.price, shopMoneyFormat);
        }

        if (sizeDisplayEl) {
          sizeDisplayEl.textContent = newSelectedSize;
        } else {
          const singleDisplayEl = document.querySelector("[data-selected-option-0]");
          if (singleDisplayEl) singleDisplayEl.textContent = newSelectedSize;
        }
        document
          .querySelectorAll(".qv-size-pill")
          .forEach((pill) => pill.classList.remove("is-selected"));
        clickedPill.classList.add("is-selected");
        closeSizeDrawer();
      } else {
        console.warn(`Variant not found for selections:`, currentSelections);
      }
    }

    // Buka Size Guide Modal
    if (e.target.matches('[data-action="open-size-guide"]')) {
      e.stopPropagation();
      console.log("Size Guide: Triggered, stopPropagation called.");

      if (!currentProductData || !sizeGuideContent) {
        console.warn("Missing data for size guide");
        return;
      }

      const sizeTag = currentProductData.tags.find((tag) => tag.startsWith("_size-"));
      if (!sizeTag) {
        sizeGuideContent.innerHTML = "<p>Sorry, size guide not available for this product.</p>";
        openSizeGuideModal();
        return;
      }

      const handle = sizeTag.replace("_size-", "size-guide-");
      const url = `/pages/${handle}?view=content-only`;

      openSizeGuideModal();
      sizeGuideContent.innerHTML = "<p>Loading size guide...</p>";
      console.log("Fetching Size Guide from URL:", url);

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Page not found or error fetching (${response.status})`);
        const pageHtml = await response.text();
        console.log("Received Size Guide HTML:", pageHtml.substring(0, 100) + "...");

        if (pageHtml.trim() === "") {
          console.warn("Size Guide page content is empty!");
          sizeGuideContent.innerHTML = "<p>Size guide content is currently empty.</p>";
        } else {
          sizeGuideContent.textContent = ""; // Kosongkan dulu
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(pageHtml, "text/html");
            const bodyContent = doc.body.innerHTML;
            if (bodyContent) {
              sizeGuideContent.innerHTML = bodyContent;
              console.log("Size guide content successfully inserted.");
            } else {
              throw new Error("Parsed body content is empty.");
            }
          } catch (parseError) {
            console.error("Error parsing or inserting size guide HTML:", parseError);
            sizeGuideContent.innerHTML = pageHtml; // Fallback
            console.warn("Inserted potentially unsafe HTML via fallback innerHTML.");
          }
        }
      } catch (error) {
        console.error("Failed to load size guide:", error);
        sizeGuideContent.innerHTML = `<p>Could not load size guide. Error: ${error.message}</p>`;
      }
    }

    // Tutup Size Guide Modal
    if (e.target.matches('[data-action="close-size-guide"]')) {
      closeSizeGuideModal();
    }
  });

  // Listener untuk overlay size guide
  if (sizeGuideOverlay) {
    sizeGuideOverlay.addEventListener("click", closeSizeGuideModal);
  }

  // --- AJAX Cart Form Submission ---
  document.addEventListener("submit", async (e) => {
    if (e.target.matches("[data-ajax-cart-form]")) {
      e.preventDefault();
      const form = e.target;
      const submitButton = form.querySelector('button[type="submit"]');
      // Periksa apakah tombol ada sebelum melanjutkan
      if (!submitButton) return;

      const buttonTextSpan = submitButton.querySelector("span:first-child");
      const originalButtonText = buttonTextSpan
        ? buttonTextSpan.textContent
        : submitButton.textContent; // Fallback jika span tidak ada

      submitButton.disabled = true;
      if (buttonTextSpan) buttonTextSpan.textContent = "Adding...";
      else submitButton.textContent = "Adding...";

      const variantId = form.querySelector('input[name="id"]').value;
      const quantity = form.querySelector('input[name="quantity"]').value;
      const body = JSON.stringify({ items: [{ id: variantId, quantity: quantity }] });

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: body,
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || "Something went wrong");
        }

        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (buttonTextSpan) buttonTextSpan.textContent = "Added!";
        else submitButton.textContent = "Added!";

        const wasInStack = stackedProducts.some((p) => p.selectedVariant.id == variantId);
        if (wasInStack) {
          stackedProducts = stackedProducts.filter((p) => p.selectedVariant.id != variantId);
          renderStackedItems();
        }

        // Jangan otomatis tutup quick view jika submit dari stack card
        if (!form.closest(".stacked-item-card")) {
          setTimeout(() => {
            closeQuickView();
          }, 800);
        } else {
          // Reset tombol di stack card setelah delay
          setTimeout(() => {
            if (buttonTextSpan) buttonTextSpan.textContent = originalButtonText;
            else submitButton.textContent = originalButtonText;
            submitButton.disabled = false;
          }, 1500);
        }
      } catch (error) {
        console.error("AJAX Cart Error:", error);
        if (buttonTextSpan) buttonTextSpan.textContent = "Error!";
        else submitButton.textContent = "Error!";
        setTimeout(() => {
          if (buttonTextSpan) buttonTextSpan.textContent = originalButtonText;
          else submitButton.textContent = originalButtonText;
          submitButton.disabled = false;
        }, 2000);
        alert(`Error: ${error.message}`); // Beri tahu pengguna via alert juga
      }
    }
  });
}); // Menutup DOMContentLoaded

// --- Helper function formatMoney (DI LUAR DOMContentLoaded) ---
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    let parts = number.split(".");
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    let cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  const match = formatString.match(placeholderRegex);
  if (match && match[1]) {
    switch (match[1]) {
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;
    }
    let formattedValue = formatString.replace(placeholderRegex, value);
    formattedValue = formattedValue.replace(/\{\{\s*currency\s*\}\}/, "");
    // Hapus simbol mata uang bawaan Shopify jika tidak diperlukan oleh format
    formattedValue = formattedValue
      .replace("Rp", "")
      .replace("IDR", "")
      .replace("$", "")
      .replace("USD", "")
      .trim();
    // Tambahkan simbol secara manual jika perlu, misal: 'Rp ' + formattedValue
    return formattedValue; // Sesuaikan return
  } else if (formatString.includes("amount")) {
    return formatString.replace("{{amount}}", formatWithDelimiters(cents, 2, ",", "."));
  }
  console.warn("Using default money format due to unrecognized format:", formatString);
  return formatWithDelimiters(cents, 2, ",", ".");
}
